import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "./index.css";

// Проверяем поддержку современных браузеров
if (!window.fetch || !window.Promise) {
  alert("Ваш браузер устарел. Пожалуйста, обновите браузер для корректной работы системы.");
}

// После деплоя старые чанки с хешем в имени исчезают: открытая вкладка ловит
// 404 на React.lazy, и лениво подгружаемые карточки отчёта (алименты, арбитраж)
// падали в «Ошибку отображения карточки». Vite сообщает об этом событием
// vite:preloadError — перезагружаем страницу один раз, чтобы взять новый
// index. Метка в sessionStorage не даёт уйти в цикл, если чанка нет и после
// перезагрузки.
const CHUNK_RELOAD_KEY = "ctx:chunk-reload-at";
window.addEventListener("vite:preloadError", (event) => {
  try {
    const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY)) || 0;
    if (Date.now() - last < 60_000) return;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  } catch {
    // Без sessionStorage нечем остановить цикл перезагрузок — оставляем ошибку.
    return;
  }
  event.preventDefault();
  window.location.reload();
});

// Создаем root для React 18
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

// Рендерим приложение
root.render(
  <BrowserRouter future={{ v7_relativeSplatPath: true }}>
    <App />
  </BrowserRouter>,
);

// Скрыть экран загрузки
setTimeout(() => {
  const loadingScreen = document.getElementById("loading-screen");
  if (loadingScreen) {
    loadingScreen.style.display = "none";
  }
}, 100);
